import React, { Component } from 'react'


// Takes array of answer options and onClick function to generate buttons
const LoadingAnimation = () => {
    

    return (
        <div className="container-fluid">
            <div className="d-flex align-items-center justify-content-center h-100">
                <div class="lds-facebook"><div></div><div></div><div></div></div>
            </div>
        </div>
    )
}

export default LoadingAnimation